module.exports = __webpack_public_path__ + "img/06杨勇.e36b0989.jpg";